import { TradeStatusEnum } from 'src/services/interfaces/TradeStatusEnum';
import { TradePhaseEnum } from 'src/services/interfaces/trade/TradePhaseEnum';
import WorkflowTradeList from 'src/components/Refatoracao/TradeList/WorkflowTradeList';
import * as React from 'react';
import PreFraudButton from 'src/components/common/PreFraudView/ViewPreFraudButton';
import { RouteComponentProps } from 'react-router';
import { ITrade } from 'src/services/interfaces/trade/ITrade';
import ViewPendencyButton from 'src/components/common/GenericButtons/Pendency/ViewPendency/ViewPendencyButton';

interface IMyOperationPageProps extends RouteComponentProps<any> {
    trade?: ITrade;
}
export function RejectedPage(props: IMyOperationPageProps) {
    const wfStatus = [TradeStatusEnum.Rejeitado];
    const wfPhases: TradePhaseEnum[] = [];
    const cardTitle = "Operações Rejeitadas";

    return <WorkflowTradeList listStatus={wfStatus} listPhase={wfPhases} cardTitle={cardTitle} isArchiveEnabled={false} hideComissionEditButton showArchivedTrades={false}>
        <PreFraudButton />
        <ViewPendencyButton />
    </WorkflowTradeList>;
}
export default RejectedPage;


// WEBPACK FOOTER //
// ./src/pages/monitor/rejected/Rejected.page.tsx